import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/ordersetting/submodule/list', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/ordersetting_sub_module/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/ordersetting_sub_module/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/ordersetting/submodule/save', params,options)

export const update = (params, options) =>
request.post('/api/v4ward/ordersetting/submodule/update', params,options)


